import type {ComponentType} from 'react';

import {colors} from 'shells/colors/colors';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

interface Props {
    icon: ComponentType<any>;
    label: string;
    children: React.ReactNode;
}

export function EditFieldWrapper(props: Props) {
    return (
        <Stack spacing={2}>
            <Stack isHorizontal={true} alignItems='center' spacing={4}>
                <props.icon size={16} wrapWithDiv={false} color={colors.grey} />
                <Body color='dark' size='small' isBold={true} wrapAnywhere={true}>
                    {props.label}
                </Body>
            </Stack>
            {props.children}
        </Stack>
    );
}
